export const localDev = false

export const filterPath = ['/visitor', '/app/personInfo','/toLogin']



// WEBPACK FOOTER //
// ./src/utils/constant.js